import Config from '../app.config'
import Router from 'vue-router'
import Vue from 'vue'
import { wrapRouter } from 'oaf-vue-router'

import Events from './events'
import routes from './routes'
import bindFilters from './filters'

if (!process || process.env.NODE_ENV !== 'test') Vue.use(Router)

const router = new Router({
    base: Config.routerBaseUrl, // Do not modify here - shared elsewhere.
    mode: 'history',
    routes,
})

bindFilters(router)
// NOTE: Don't add a global beforeEach - It messes up the route guards.
router.afterEach(Events.afterEach)
router.beforeResolve(Events.beforeResolve)
wrapRouter(router)

export default router
